import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const cbuApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCBUBankList: builder.query({
            query: ({ page, limitNumber, params }) => {
                return {
                    url: `/bouser/admin/getCBUBankList/${page}/params`,
                    params: { limitNumber, ...removeEmptyKeys(params) },
                }
            },
            transformResponse: (response, meta, args) => {
                return {
                    cbuList: response.cbuList,
                    usersList: response.usersList,
                    countStudent: response.countStudent,
                    pagesStudent: response.pagesStudent,
                    countUser: response.countUser,
                    pagesUser: response.pagesUser,
                }
            },
            providesTags: ['bouser'],
        }),
        importListCBU: builder.mutation({
            query: ({ cbuList }) => {
                return {
                    url: '/bouser/admin/importListCBU',
                    method: 'POST',
                    body: { cbuList },
                }
            },
            transformResponse: (response, meta, args) => {
                return {
                    message: response.message,
                    okImport: response.okImport,
                    errorImport: response.errorImport,
                    procesed: response.procesed,
                    hadNotAccount: response.hadNotAccount,
                    seted: response.seted,
                    notOwnerList: response.notOwnerList,
                }
            },
            invalidatesTags: ['bouser'],
        }),
        setBankAccount: builder.mutation({
            query: () => {
                return {
                    url: '/bouser/admin/setBankAccount',
                    method: 'POST',
                }
            },
            transformResponse: (response, meta, args) => {
                return {
                    message: response.message,
                    procesed: response.procesed,
                    hadNotAccount: response.hadNotAccount,
                    seted: response.seted,
                    notOwnerList: response.notOwnerList
                }
            },
            invalidatesTags: ['bouser'],
        }),

    }),
    overrideExisting: true,
})

export const {
    useGetCBUBankListQuery,
    useImportListCBUMutation,
    useSetBankAccountMutation,
} = cbuApiSlice
